
import { css } from 'lit';
export default css`
:host{
  --rectangle-size:6px;
  --rectangle-color:var(--purple-indigo-light);

  display:contents;
}

.rectangle{
  display:inline-block;
  border-radius:2px;
  background:var(--rectangle-color);
  width:var(--rectangle-size);
  height:var(--rectangle-size);
}
`;